module.exports = __webpack_public_path__ + "img/volume_offline.d5796459.svg";